module.exports = __webpack_public_path__ + "touch.47815386713d401694ac.jpg";